"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var O = __importStar(require("fp-ts/Option"));
var Option_1 = require("fp-ts/Option");
var function_1 = require("fp-ts/function");
var React = __importStar(require("react"));
var ReactDOM = __importStar(require("react-dom"));
var index_1 = require("../index");
require("./modal.css");
var body = document.getElementsByTagName('body')[0];
var Modal = /** @class */ (function (_super) {
    __extends(Modal, _super);
    function Modal(props) {
        var _this = _super.call(this, props) || this;
        _this.setMarginTop = function () {
            return (0, function_1.pipe)(O.fromNullable(_this.modalElement), O.map(function (modalElement) {
                if (modalElement.clientHeight > document.documentElement.clientHeight) {
                    modalElement.style.marginTop = '150px';
                }
            }));
        };
        _this.modalElement = null;
        _this.wrapperElement = document.createElement('div');
        return _this;
    }
    // eslint-disable-next-line react/no-deprecated
    Modal.prototype.componentWillMount = function () {
        body.dataset.modalIsOpen = 'true';
        body.style.overflow = 'hidden';
    };
    Modal.prototype.componentDidMount = function () {
        this.props.modalRoot.appendChild(this.wrapperElement);
        this.setMarginTop();
    };
    Modal.prototype.componentWillUnmount = function () {
        body.removeAttribute('data-modal-is-open');
        body.style.overflow = 'auto';
        this.props.modalRoot.removeChild(this.wrapperElement);
    };
    Modal.prototype.showHeader = function (modalType) {
        var _this = this;
        return (0, function_1.pipe)(O.some(modalType), O.chain(function (mt) { return (_this.props.title !== undefined ? O.some(mt) : O.none); }), O.chainNullableK(function (mT) { return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, clsx_1.default)('modal-header', "modal-header-".concat(mT)) }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ "data-test": "modal-title", className: "modal-title" }, { children: _this.props.title })), (0, function_1.pipe)(O.fromNullable(_this.props.preventClose), O.filter(function (preventClose) { return preventClose === true; }), O.match(function () { return ((0, jsx_runtime_1.jsx)("div", __assign({ "data-test": "modal-close", className: (0, clsx_1.default)('modal-close', "modal-close-".concat(_this.props.modalType)), onClick: _this.props.onClose }, { children: (0, jsx_runtime_1.jsx)(index_1.Icon, { icon: "icon_close_dark" }) }))); }, function (_) { return null; }))] }))); }), O.toNullable);
    };
    Modal.prototype.render = function () {
        var _this = this;
        return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: ReactDOM.createPortal((0, jsx_runtime_1.jsx)("div", __assign({ className: "modal-dimmer" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: (0, clsx_1.default)('modal', "modal-".concat(this.props.modalType), "size-".concat(this.props.size)), ref: function (modalElement) {
                        _this.modalElement = modalElement;
                    } }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ "data-test": "modal-body", className: (0, clsx_1.default)('modal-body', "modal-body-".concat(this.props.modalType)) }, { children: [this.showHeader(this.props.modalType), this.props.children] })) })) })), this.wrapperElement) }));
    };
    Modal.Content = function (props) { return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "modal-content" }, { children: props.children }))); };
    Modal.PreFooter = function (props) { return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "modal-pre-footer" }, { children: [(0, function_1.pipe)(O.fromNullable(props.icon), (0, Option_1.map)(function (icon) { return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "modal-pre-footer-icon" }, { children: (0, jsx_runtime_1.jsx)(index_1.Icon, { icon: icon }) }))); }), O.toNullable), (0, jsx_runtime_1.jsx)("div", __assign({ className: "modal-pre-footer-content" }, { children: props.children }))] }))); };
    Modal.Footer = function (props) { return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "modal-footer ".concat(props.borderless ? 'borderless' : '') }, { children: props.children }))); };
    return Modal;
}(React.PureComponent));
exports.Modal = Modal;
Modal.defaultProps = {
    size: 'std',
    modalRoot: document.getElementById('modal-root'),
};
//# sourceMappingURL=Modal.js.map